import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** ADD THRIFT DETAILS START *********************** */
export const savingsDetailsAdd = (addData: JSON) => {
	const data = {
		AddSavingsDetailsToken: addData,
	};
	const url = `${API_URL}addSavingsDetails`;
	return makeApiCall(url, data);
};
/** ***************** ADD THRIFT DETAILS END *********************** */

/** ***************** UPDATE THRIFT DETAILS START *********************** */
export const savingsDetailsUpdate = (updateData: JSON) => {
	const data = {
		UpdateSavingsDetailsToken: updateData,
	};
	const url = `${API_URL}updateSavingsDetails`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE THRIFT DETAILS END *********************** */

/** ***************** GET THRIFT LIST START *********************** */
export const savingsListGet = (listData: JSON) => {
	const data = {
		GetSavingsListToken: listData,
	};
	const url = `${API_URL}getSavingsList`;
	return makeApiCall(url, data);
};
/** ***************** GET THRIFT LIST END *********************** */

/** ***************** FETCH THRIFT DETAILS START *********************** */
export const savingsDetailsFetch = (fetchData: JSON) => {
	const data = {
		FetchSavingsDetailsToken: fetchData,
	};
	const url = `${API_URL}fetchSavingsDetails`;
	return makeApiCall(url, data);
};
/** ***************** FETCH THRIFT DETAILS END *********************** */

/** ***************** DELETE THRIFT DETAILS START *********************** */
export const savingsDetailsDelete = (deleteData: JSON) => {
	const data = {
		DeleteSavingsDetailsToken: deleteData,
	};
	const url = `${API_URL}deleteSavingsDetails`;
	return makeApiCall(url, data);
};
/** ***************** DELETE THRIFT DETAILS END *********************** */

/** ***************** FETCH ALL THRIFT LIST START *********************** */
export const allSavingsFetch = (fetchAllThriftData: JSON) => {
	const data = {
		AllSavingsListFetchToken: fetchAllThriftData,
	};
	const url = `${API_URL}fetchAllSavingsList`;
	return makeApiCall(url, data);
};
/** ***************** FETCH ALL THRIFT LIST END *********************** */
